const docReloadIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#FFF" stroke-linecap="round" stroke-linejoin="round">
          <g transform="translate(11.667 11.667)">
            <polyline points="7.917 .833 7.917 2.917 5.833 2.917"/>
            <path d="M0.416666667,2.91666667 C0.930833333,1.46083333 2.53416667,0.416666667 4.16666667,0.416666667 C5.79916667,0.416666667 7.4025,1.46083333 7.91666667,2.91666667"/>
            <g transform="translate(0 5)">
              <polyline points=".417 2.5 .417 .417 2.5 .417"/>
              <path d="M7.91666667,0.416666667 C7.4025,1.87333333 5.79916667,2.91666667 4.16666667,2.91666667 C2.53416667,2.91666667 0.930833333,1.87333333 0.416666667,0.416666667"/>
            </g>
          </g>
          <circle cx="4.167" cy="5.833" r="1.25"/>
          <polyline points="8.75 17.917 .417 17.917 .417 .417 9.583 .417 13.75 4.583 13.75 9.583"/>
          <polyline points="9.583 .417 9.583 4.583 13.75 4.583"/>
          <polyline points="10.403 10.834 9.167 7.5 6.667 12.083 5 10.417 2.917 14.583 7.467 14.583"/>
        </g>
        <rect width="20" height="20"/>
      </g>
    </svg>
`;

export default docReloadIcon;
